import * as S from './styles'

export const PageTitle = ({ children }) => <S.PageTitle>{children}</S.PageTitle>
